export default class DatapointCollection {
  public labels: Array<string>;
  public datasets;

  constructor(options) {
    this.labels = options.labels;
    this.datasets = options.datasets;
  }

  render() {
    return {
      labels: this.labels,
      datasets: this.datasets,
    };
  }
}
